export const GOT_PHOTOS = 'GOT PHOTOS'
export const GET_PHOTOS = 'GETTING PHOTOS'
export const DEL_PHOTO = 'DEL_PHOTO'
export const UP_PHOTO = 'UPLOAD_PHOTO'
export const PHOTO_ERROR = 'PHOTO_ERROR'
